import FieldInput from '../TicketRow/Field/FieldInput'
import FieldSelect from '../TicketRow/Field/FieldSelect'

import styles from './index.module.scss'

export default function EventFields() {

    return (
        <div className={styles.container}>
            <h4>Please let us know the following</h4>
            <div className={styles.fields}>
                {window.extra_acf_event_fields.map(field => {
                    
                    switch(field.type) {
                        case 'text':
                        case 'email':
                            return <FieldInput name={field.name} field={{ label: field.label }} />
                        case 'select':
                            return <FieldSelect name={field.name} field={{ label: field.label, options: Object.keys(field.choices) }} />
                    }

                })}
            </div>
        </div>
    )

}
